module.exports = __webpack_public_path__ + "static/img/situacao_fiscal.2683ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/situacao_fiscal.png
// module id = 840
// module chunks = 0